var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span>\n  <a href="#" class="substitution-param-item" data-title="'+
((__t=( id ))==null?'':_.escape(__t))+
'">\n    '+
((__t=( title ))==null?'':__t)+
'\n  </a>\n  '+
((__t=( badges ))==null?'':__t)+
'\n</span>\n';
}
return __p;
};
